import { render, staticRenderFns } from "./Exercise1.vue?vue&type=template&id=47e1e082&"
import script from "./Exercise1.vue?vue&type=script&lang=js&"
export * from "./Exercise1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports